// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.retrigger-modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 1100;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(15, 23, 42, 0.55);
  backdrop-filter: blur(2px);
}

.retrigger-modal {
  width: 100%;
  max-width: 560px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  box-shadow:
    0 24px 48px rgba(15, 23, 42, 0.18),
    0 8px 16px rgba(15, 23, 42, 0.08);
  overflow: hidden;
  animation: retriggerModalIn 0.22s ease-out;
}

@keyframes retriggerModalIn {
  from {
    opacity: 0;
    transform: translateY(12px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.retrigger-modal-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding: 22px 24px 18px;
  border-bottom: 1px solid #eef2f7;
  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
}

.retrigger-modal-header-main {
  display: flex;
  align-items: flex-start;
  gap: 14px;
}

.retrigger-modal-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  border-radius: 10px;
  background: #eef2ff;
  color: #4f46e5;
  flex-shrink: 0;
}

.retrigger-modal-title {
  margin: 0;
  font-size: 1.125rem;
  font-weight: 700;
  color: #0f172a;
  line-height: 1.3;
}

.retrigger-modal-subtitle {
  margin: 4px 0 0;
  font-size: 0.875rem;
  color: #64748b;
  line-height: 1.4;
}

.retrigger-modal-close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: #64748b;
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease;
}

.retrigger-modal-close:hover {
  background: #f1f5f9;
  color: #0f172a;
}

.retrigger-modal-body {
  padding: 20px 24px 8px;
}

.retrigger-modal-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 28px 12px 36px;
}

.retrigger-modal-spinner {
  width: 44px;
  height: 44px;
  border: 3px solid #e2e8f0;
  border-top-color: #667eea;
  border-radius: 50%;
  animation: retriggerSpin 0.75s linear infinite;
  margin-bottom: 16px;
}

@keyframes retriggerSpin {
  to {
    transform: rotate(360deg);
  }
}

.retrigger-modal-loading-title {
  margin: 0 0 6px;
  font-size: 0.95rem;
  font-weight: 600;
  color: #0f172a;
}

.retrigger-modal-loading-text {
  margin: 0;
  font-size: 0.875rem;
  color: #64748b;
}

.retrigger-modal-alert {
  display: flex;
  gap: 12px;
  padding: 14px 16px;
  border-radius: 10px;
  border: 1px solid transparent;
  margin-bottom: 18px;
}

.retrigger-modal-alert-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  font-size: 0.875rem;
  font-weight: 700;
  flex-shrink: 0;
}

.retrigger-modal-alert-title {
  margin: 0 0 4px;
  font-size: 0.875rem;
  font-weight: 700;
  line-height: 1.3;
}

.retrigger-modal-alert-text {
  margin: 0;
  font-size: 0.8125rem;
  line-height: 1.5;
}

.retrigger-modal-alert--success {
  background: #ecfdf5;
  border-color: #a7f3d0;
  color: #065f46;
}

.retrigger-modal-alert--success .retrigger-modal-alert-icon {
  background: #d1fae5;
  color: #047857;
}

.retrigger-modal-alert--warning {
  background: #fffbeb;
  border-color: #fde68a;
  color: #92400e;
}

.retrigger-modal-alert--warning .retrigger-modal-alert-icon {
  background: #fef3c7;
  color: #b45309;
}

.retrigger-modal-alert--info,
.retrigger-modal-alert--neutral {
  background: #eff6ff;
  border-color: #bfdbfe;
  color: #1e40af;
}

.retrigger-modal-alert--info .retrigger-modal-alert-icon,
.retrigger-modal-alert--neutral .retrigger-modal-alert-icon {
  background: #dbeafe;
  color: #1d4ed8;
}

.retrigger-modal-alert--error {
  background: #fef2f2;
  border-color: #fecaca;
  color: #991b1b;
}

.retrigger-modal-alert--error .retrigger-modal-alert-icon {
  background: #fee2e2;
  color: #b91c1c;
}

.retrigger-modal-details {
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-height: 420px;
  overflow-y: auto;
}

.retrigger-bulk-entry {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-bottom: 12px;
  border-bottom: 1px solid #e2e8f0;
}

.retrigger-bulk-entry:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

.retrigger-bulk-entry-header {
  margin: 0;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #4f46e5;
}

.retrigger-detail-card {
  padding: 14px 16px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
}

.retrigger-detail-card--highlight {
  background: #ffffff;
  border-color: #cbd5e1;
}

.retrigger-detail-label {
  display: block;
  margin-bottom: 6px;
  font-size: 0.6875rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #64748b;
}

.retrigger-detail-value {
  display: block;
  font-size: 0.9375rem;
  line-height: 1.55;
  color: #0f172a;
  word-break: break-word;
}

.retrigger-detail-value--mono {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', monospace;
  font-size: 0.9rem;
  font-weight: 600;
  letter-spacing: 0.02em;
}

.retrigger-status-badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 0.8125rem;
  font-weight: 600;
}

.retrigger-status-badge--success {
  background: #d1fae5;
  color: #047857;
}

.retrigger-status-badge--warning {
  background: #fef3c7;
  color: #b45309;
}

.retrigger-status-badge--info,
.retrigger-status-badge--neutral {
  background: #e0e7ff;
  color: #4338ca;
}

.retrigger-modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 16px 24px 20px;
  border-top: 1px solid #eef2f7;
  background: #fafbfc;
}

.retrigger-btn {
  min-width: 96px;
  height: 38px;
  padding: 0 16px;
  border-radius: 8px;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}

.retrigger-btn--primary {
  border: 1px solid #667eea;
  background: #667eea;
  color: #ffffff;
}

.retrigger-btn--primary:hover {
  background: #5a67d8;
  border-color: #5a67d8;
}

.retrigger-btn--secondary {
  border: 1px solid #e2e8f0;
  background: #ffffff;
  color: #475569;
}

.retrigger-btn--secondary:hover {
  background: #f8fafc;
  border-color: #cbd5e1;
}

@media (max-width: 768px) {
  .retrigger-modal-overlay {
    padding: 0;
    align-items: flex-end;
  }

  .retrigger-modal {
    width: 100%;
    max-width: none;
    max-height: 92dvh;
    border-radius: 16px 16px 0 0;
  }

  .retrigger-modal-footer {
    flex-direction: column-reverse;
    gap: 8px;
  }

  .retrigger-modal-footer .retrigger-btn {
    width: 100%;
  }
}

@media (max-width: 640px) {
  .retrigger-modal-overlay {
    padding: 0;
  }

  .retrigger-modal-header,
  .retrigger-modal-body,
  .retrigger-modal-footer {
    padding-left: 16px;
    padding-right: 16px;
  }
}

/* ===== Dark theme overrides (light mode untouched) ===== */
[data-theme="dark"] .retrigger-modal {
  background: var(--surface);
  border-color: var(--border);
}
[data-theme="dark"] .retrigger-modal-header {
  border-bottom-color: var(--border);
  background: var(--surface-2);
}
[data-theme="dark"] .retrigger-modal-title,
[data-theme="dark"] .retrigger-modal-loading-title,
[data-theme="dark"] .retrigger-detail-value {
  color: var(--text-strong);
}
[data-theme="dark"] .retrigger-modal-subtitle,
[data-theme="dark"] .retrigger-modal-close,
[data-theme="dark"] .retrigger-modal-loading-text,
[data-theme="dark"] .retrigger-detail-label {
  color: var(--text-muted);
}
[data-theme="dark"] .retrigger-modal-close:hover {
  background: var(--surface-3);
  color: var(--text);
}
[data-theme="dark"] .retrigger-detail-card {
  background: var(--surface-2);
  border-color: var(--border);
}
[data-theme="dark"] .retrigger-detail-card--highlight {
  background: var(--surface);
  border-color: var(--border-strong);
}
[data-theme="dark"] .retrigger-bulk-entry {
  border-bottom-color: var(--border);
}
[data-theme="dark"] .retrigger-modal-footer {
  border-top-color: var(--border);
  background: var(--surface-2);
}
[data-theme="dark"] .retrigger-btn--secondary {
  background: var(--surface);
  border-color: var(--border);
  color: var(--text);
}
[data-theme="dark"] .retrigger-btn--secondary:hover {
  background: var(--surface-2);
  border-color: var(--border-strong);
}
`, "",{"version":3,"sources":["webpack://./src/components/RetriggerIdocModal/index.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB;;qCAEmC;EACnC,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;EACvB,gCAAgC;EAChC,6DAA6D;AAC/D;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,yDAAyD;AAC3D;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,8CAA8C;EAC9C,mBAAmB;AACrB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,iBAAiB;EACjB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,gGAAgG;EAChG,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,uBAAuB;EACvB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,kFAAkF;AACpF;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,4BAA4B;EAC9B;;EAEA;IACE,8BAA8B;IAC9B,QAAQ;EACV;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;;;IAGE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA,4DAA4D;AAC5D;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;AACA;EACE,kCAAkC;EAClC,4BAA4B;AAC9B;AACA;;;EAGE,yBAAyB;AAC3B;AACA;;;;EAIE,wBAAwB;AAC1B;AACA;EACE,4BAA4B;EAC5B,kBAAkB;AACpB;AACA;EACE,4BAA4B;EAC5B,2BAA2B;AAC7B;AACA;EACE,0BAA0B;EAC1B,kCAAkC;AACpC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,+BAA+B;EAC/B,4BAA4B;AAC9B;AACA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,kBAAkB;AACpB;AACA;EACE,4BAA4B;EAC5B,kCAAkC;AACpC","sourcesContent":[".retrigger-modal-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 1100;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  background: rgba(15, 23, 42, 0.55);\n  backdrop-filter: blur(2px);\n}\n\n.retrigger-modal {\n  width: 100%;\n  max-width: 560px;\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: 14px;\n  box-shadow:\n    0 24px 48px rgba(15, 23, 42, 0.18),\n    0 8px 16px rgba(15, 23, 42, 0.08);\n  overflow: hidden;\n  animation: retriggerModalIn 0.22s ease-out;\n}\n\n@keyframes retriggerModalIn {\n  from {\n    opacity: 0;\n    transform: translateY(12px) scale(0.98);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n.retrigger-modal-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 22px 24px 18px;\n  border-bottom: 1px solid #eef2f7;\n  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);\n}\n\n.retrigger-modal-header-main {\n  display: flex;\n  align-items: flex-start;\n  gap: 14px;\n}\n\n.retrigger-modal-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 42px;\n  height: 42px;\n  border-radius: 10px;\n  background: #eef2ff;\n  color: #4f46e5;\n  flex-shrink: 0;\n}\n\n.retrigger-modal-title {\n  margin: 0;\n  font-size: 1.125rem;\n  font-weight: 700;\n  color: #0f172a;\n  line-height: 1.3;\n}\n\n.retrigger-modal-subtitle {\n  margin: 4px 0 0;\n  font-size: 0.875rem;\n  color: #64748b;\n  line-height: 1.4;\n}\n\n.retrigger-modal-close {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 34px;\n  height: 34px;\n  border: none;\n  border-radius: 8px;\n  background: transparent;\n  color: #64748b;\n  cursor: pointer;\n  transition: background-color 0.15s ease, color 0.15s ease;\n}\n\n.retrigger-modal-close:hover {\n  background: #f1f5f9;\n  color: #0f172a;\n}\n\n.retrigger-modal-body {\n  padding: 20px 24px 8px;\n}\n\n.retrigger-modal-loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  padding: 28px 12px 36px;\n}\n\n.retrigger-modal-spinner {\n  width: 44px;\n  height: 44px;\n  border: 3px solid #e2e8f0;\n  border-top-color: #667eea;\n  border-radius: 50%;\n  animation: retriggerSpin 0.75s linear infinite;\n  margin-bottom: 16px;\n}\n\n@keyframes retriggerSpin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.retrigger-modal-loading-title {\n  margin: 0 0 6px;\n  font-size: 0.95rem;\n  font-weight: 600;\n  color: #0f172a;\n}\n\n.retrigger-modal-loading-text {\n  margin: 0;\n  font-size: 0.875rem;\n  color: #64748b;\n}\n\n.retrigger-modal-alert {\n  display: flex;\n  gap: 12px;\n  padding: 14px 16px;\n  border-radius: 10px;\n  border: 1px solid transparent;\n  margin-bottom: 18px;\n}\n\n.retrigger-modal-alert-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  font-size: 0.875rem;\n  font-weight: 700;\n  flex-shrink: 0;\n}\n\n.retrigger-modal-alert-title {\n  margin: 0 0 4px;\n  font-size: 0.875rem;\n  font-weight: 700;\n  line-height: 1.3;\n}\n\n.retrigger-modal-alert-text {\n  margin: 0;\n  font-size: 0.8125rem;\n  line-height: 1.5;\n}\n\n.retrigger-modal-alert--success {\n  background: #ecfdf5;\n  border-color: #a7f3d0;\n  color: #065f46;\n}\n\n.retrigger-modal-alert--success .retrigger-modal-alert-icon {\n  background: #d1fae5;\n  color: #047857;\n}\n\n.retrigger-modal-alert--warning {\n  background: #fffbeb;\n  border-color: #fde68a;\n  color: #92400e;\n}\n\n.retrigger-modal-alert--warning .retrigger-modal-alert-icon {\n  background: #fef3c7;\n  color: #b45309;\n}\n\n.retrigger-modal-alert--info,\n.retrigger-modal-alert--neutral {\n  background: #eff6ff;\n  border-color: #bfdbfe;\n  color: #1e40af;\n}\n\n.retrigger-modal-alert--info .retrigger-modal-alert-icon,\n.retrigger-modal-alert--neutral .retrigger-modal-alert-icon {\n  background: #dbeafe;\n  color: #1d4ed8;\n}\n\n.retrigger-modal-alert--error {\n  background: #fef2f2;\n  border-color: #fecaca;\n  color: #991b1b;\n}\n\n.retrigger-modal-alert--error .retrigger-modal-alert-icon {\n  background: #fee2e2;\n  color: #b91c1c;\n}\n\n.retrigger-modal-details {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  max-height: 420px;\n  overflow-y: auto;\n}\n\n.retrigger-bulk-entry {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.retrigger-bulk-entry:last-child {\n  border-bottom: none;\n  padding-bottom: 0;\n}\n\n.retrigger-bulk-entry-header {\n  margin: 0;\n  font-size: 0.75rem;\n  font-weight: 700;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  color: #4f46e5;\n}\n\n.retrigger-detail-card {\n  padding: 14px 16px;\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n}\n\n.retrigger-detail-card--highlight {\n  background: #ffffff;\n  border-color: #cbd5e1;\n}\n\n.retrigger-detail-label {\n  display: block;\n  margin-bottom: 6px;\n  font-size: 0.6875rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: #64748b;\n}\n\n.retrigger-detail-value {\n  display: block;\n  font-size: 0.9375rem;\n  line-height: 1.55;\n  color: #0f172a;\n  word-break: break-word;\n}\n\n.retrigger-detail-value--mono {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', monospace;\n  font-size: 0.9rem;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n}\n\n.retrigger-status-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 4px 10px;\n  border-radius: 999px;\n  font-size: 0.8125rem;\n  font-weight: 600;\n}\n\n.retrigger-status-badge--success {\n  background: #d1fae5;\n  color: #047857;\n}\n\n.retrigger-status-badge--warning {\n  background: #fef3c7;\n  color: #b45309;\n}\n\n.retrigger-status-badge--info,\n.retrigger-status-badge--neutral {\n  background: #e0e7ff;\n  color: #4338ca;\n}\n\n.retrigger-modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  padding: 16px 24px 20px;\n  border-top: 1px solid #eef2f7;\n  background: #fafbfc;\n}\n\n.retrigger-btn {\n  min-width: 96px;\n  height: 38px;\n  padding: 0 16px;\n  border-radius: 8px;\n  font-size: 0.875rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease;\n}\n\n.retrigger-btn--primary {\n  border: 1px solid #667eea;\n  background: #667eea;\n  color: #ffffff;\n}\n\n.retrigger-btn--primary:hover {\n  background: #5a67d8;\n  border-color: #5a67d8;\n}\n\n.retrigger-btn--secondary {\n  border: 1px solid #e2e8f0;\n  background: #ffffff;\n  color: #475569;\n}\n\n.retrigger-btn--secondary:hover {\n  background: #f8fafc;\n  border-color: #cbd5e1;\n}\n\n@media (max-width: 768px) {\n  .retrigger-modal-overlay {\n    padding: 0;\n    align-items: flex-end;\n  }\n\n  .retrigger-modal {\n    width: 100%;\n    max-width: none;\n    max-height: 92dvh;\n    border-radius: 16px 16px 0 0;\n  }\n\n  .retrigger-modal-footer {\n    flex-direction: column-reverse;\n    gap: 8px;\n  }\n\n  .retrigger-modal-footer .retrigger-btn {\n    width: 100%;\n  }\n}\n\n@media (max-width: 640px) {\n  .retrigger-modal-overlay {\n    padding: 0;\n  }\n\n  .retrigger-modal-header,\n  .retrigger-modal-body,\n  .retrigger-modal-footer {\n    padding-left: 16px;\n    padding-right: 16px;\n  }\n}\n\n/* ===== Dark theme overrides (light mode untouched) ===== */\n[data-theme=\"dark\"] .retrigger-modal {\n  background: var(--surface);\n  border-color: var(--border);\n}\n[data-theme=\"dark\"] .retrigger-modal-header {\n  border-bottom-color: var(--border);\n  background: var(--surface-2);\n}\n[data-theme=\"dark\"] .retrigger-modal-title,\n[data-theme=\"dark\"] .retrigger-modal-loading-title,\n[data-theme=\"dark\"] .retrigger-detail-value {\n  color: var(--text-strong);\n}\n[data-theme=\"dark\"] .retrigger-modal-subtitle,\n[data-theme=\"dark\"] .retrigger-modal-close,\n[data-theme=\"dark\"] .retrigger-modal-loading-text,\n[data-theme=\"dark\"] .retrigger-detail-label {\n  color: var(--text-muted);\n}\n[data-theme=\"dark\"] .retrigger-modal-close:hover {\n  background: var(--surface-3);\n  color: var(--text);\n}\n[data-theme=\"dark\"] .retrigger-detail-card {\n  background: var(--surface-2);\n  border-color: var(--border);\n}\n[data-theme=\"dark\"] .retrigger-detail-card--highlight {\n  background: var(--surface);\n  border-color: var(--border-strong);\n}\n[data-theme=\"dark\"] .retrigger-bulk-entry {\n  border-bottom-color: var(--border);\n}\n[data-theme=\"dark\"] .retrigger-modal-footer {\n  border-top-color: var(--border);\n  background: var(--surface-2);\n}\n[data-theme=\"dark\"] .retrigger-btn--secondary {\n  background: var(--surface);\n  border-color: var(--border);\n  color: var(--text);\n}\n[data-theme=\"dark\"] .retrigger-btn--secondary:hover {\n  background: var(--surface-2);\n  border-color: var(--border-strong);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
